import React from 'react';

import ErrorIcon from '../../assets/svg-components/thank-you/error.svg';
import './notice.scss';

interface NoticeProps {
  title: React.ReactNode;
}

const Notice: React.FC<NoticeProps> = ({ children, title }) => {
  return (
    <div className="rc-notice">
      <ErrorIcon />
      <div className="rc-notice-content">
        <h6 className="rc-notice__title">{title}</h6>
        {children}
      </div>
    </div>
  );
};

export default Notice;
